<form [formGroup]="form">
  <ix-input
    formControlName="name"
    [label]="'Name' | translate"
    [required]="true"
    [tooltip]="helptext.add.name.tooltip | translate"
  ></ix-input>

  <ix-select
    formControlName="create_type"
    [label]="'Type' | translate"
    [required]="true"
    [options]="createTypes$"
    [tooltip]="helptext.add.create_type.tooltip | translate"
  ></ix-select>

  <ix-select
    *ngIf="!isCaImport"
    formControlName="profile"
    [label]="'Profile' | translate"
    [options]="profileOptions$"
    [tooltip]="helptext.add.profiles.tooltip | translate"
  ></ix-select>

  <ix-checkbox
    *ngIf="!isIntermediate"
    formControlName="add_to_trusted_store"
    class="add-to-trusted-store"
    [label]="'Add To Trusted Store' | translate"
  ></ix-checkbox>

  <ix-form-actions>
    <button
      mat-button
      matStepperNext
      color="primary"
      ixTest="next"
      [disabled]="form.invalid"
    >{{ 'Next' | translate }}</button>
  </ix-form-actions>
</form>
